import { TYPES } from "./draft_dialog.type";

const initState = {
  draftDialogAll: null,
  draftDialogOpenAdd: false,
  draftDialogOpenEdit: false,
  draftDialogSelected: null,
  draftDialogSearch: "",
  //
  draftDialogDetail: null,
  //
  draftDialogOpenDeny: false,
  draftDialogOpenWarn: false,
  draftDialogOpenForward: false,
  draftDialogAudioUrl: null,
  draftDialogEditCard: false,
  //
  draftDialogPlay: false,
  draftDialogSecond: 0,
  draftDialogKick: null,
  // for advance editor
  draftDialogOpenAdvance: false,
  draftDialogEditorData: [],
  draftDialogEditorEdit: null,
  // speaker
  draftDialogSpeakerColor: null,
  draftDialogSpeakerName: null,
  draftDialogAdvanceScale: 5,
  draftDialogAdvanceSelected: null,
  draftDialogAdvanceUndo: null,
  draftDialogAdvanceSave: null,

  //merge
  drafDialogMergeRaw: null,
  draftDialogSpeakersRaw: [],
  draftDialogMerge: null,
  draftDialogSpeakers: [],
  draftDialogComments: [],
};

const draftDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DRAFT_DIALOG_KICK:
      return {
        ...state,
        draftDialogKick: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SECOND:
      return {
        ...state,
        draftDialogSecond: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_PLAY:
      return {
        ...state,
        draftDialogPlay: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_AUDIO_URL:
      return {
        ...state,
        draftDialogAudioUrl: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_DENY:
      return {
        ...state,
        draftDialogOpenDeny: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_WARN:
      return {
        ...state,
        draftDialogOpenWarn: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_FORWARD:
      return {
        ...state,
        draftDialogOpenForward: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_DETAIL:
      return {
        ...state,
        draftDialogDetail: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ALL:
      return {
        ...state,
        draftDialogAll: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_ADD:
      return {
        ...state,
        draftDialogOpenAdd: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_EDIT:
      return {
        ...state,
        draftDialogOpenEdit: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SELECTED:
      return {
        ...state,
        draftDialogSelected: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SEARCH:
      return {
        ...state,
        draftDialogSearch: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_OPEN_ADVANCE:
      return {
        ...state,
        draftDialogOpenAdvance: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_EDITOR_DATA:
      return {
        ...state,
        draftDialogEditorData: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_EDITOR_EDIT:
      return {
        ...state,
        draftDialogEditorEdit: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SPEAKER_COLOR:
      return {
        ...state,
        draftDialogSpeakerColor: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SPEAKER_NAME:
      return {
        ...state,
        draftDialogSpeakerName: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ADVANCE_SCALE:
      return {
        ...state,
        draftDialogAdvanceScale: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ADVANCE_SELECTED:
      return {
        ...state,
        draftDialogAdvanceSelected: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ADVANCE_UNDO:
      return {
        ...state,
        draftDialogAdvanceUndo: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_ADVANCE_SAVE:
      return {
        ...state,
        draftDialogAdvanceSave: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_EDIT_CARD:
      return {
        ...state,
        draftDialogEditCard: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_MERGE_RAW:
      return {
        ...state,
        draftDialogMergeRaw: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_MERGE:
      return {
        ...state,
        draftDialogMerge: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SPEAKERS:
      return {
        ...state,
        draftDialogSpeakers: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_SPEAKERS_RAW:
      return {
        ...state,
        draftDialogSpeakersRaw: payload,
      };

    case TYPES.SET_DRAFT_DIALOG_COMMENTS:
      return {
        ...state,
        draftDialogComments: payload,
      };

    default:
      return state;
  }
};

export default draftDialogReducer;
